import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import { db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";
import {
  calcularCaracterizacaoFiler,
  calcularCaracterizacaoGraudo,
  calcularCaracterizacaoMiudo,
  densidadeAguaPorTemperatura,
  numeroCbuq,
  TABELA_DENSIDADE_AGUA_DNIT,
} from "../CadastroTracoCbuq/tracoCbuqCalculos";
import { COLECAO_CARACTERIZACAO_ASFALTO } from "./CadastroCaracterizacaoAsfalto";
import {
  COLLECTION_FAIXAS_DNIT_ASFALTO,
  FAIXAS_DNIT_ASFALTO,
  criarGranulometriaAsfalto,
  faixasDnitAsfaltoPadrao,
  recalcularGranulometriaAsfalto,
} from "./faixasDnitAsfaltoModel";

function formatarNumero(valor, casas = 3) {
  const numero = numeroCbuq(valor);
  return numero === null
    ? "-"
    : numero.toLocaleString("pt-BR", {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
      });
}

function formatarData(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

function Informacao({ label, valor }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, flex: 1 }}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography fontWeight={700}>{valor || "-"}</Typography>
    </Paper>
  );
}

function avancarCampoAbaixo(event, coluna) {
  if (event.key !== "Enter") return;
  event.preventDefault();

  const camposDaColuna = Array.from(
    document.querySelectorAll(`[data-caracterizacao-asfalto-coluna="${coluna}"]`)
  );
  const campoAtual = event.target.closest?.(
    `[data-caracterizacao-asfalto-coluna="${coluna}"]`
  );
  const indiceAtual = camposDaColuna.indexOf(campoAtual);
  if (indiceAtual < 0) return;
  const proximoCampo = camposDaColuna[indiceAtual + 1];

  if (proximoCampo) {
    proximoCampo.focus();
    proximoCampo.select();
  }
}

function serializarEstadoEditavel(registro) {
  return JSON.stringify({
    determinacoes: registro?.determinacoes || [],
    temperaturaAgua: registro?.temperaturaAgua ?? "25",
    faixaDnitAsfalto: registro?.faixaDnitAsfalto || "C125",
    dataGranulometria: registro?.dataGranulometria || "",
    operadorGranulometria: registro?.operadorGranulometria || "",
    massaInicialGranulometriaA: registro?.massaInicialGranulometriaA || "",
    massaInicialGranulometriaB: registro?.massaInicialGranulometriaB || "",
    granulometriaAsfalto: registro?.granulometriaAsfalto || [],
    qualificacao: registro?.qualificacao || {},
    observacoes: registro?.observacoes || "",
  });
}

function avancarGranulometriaComEnter(event, coluna) {
  if (event.key !== "Enter") return;
  event.preventDefault();
  const campos = Array.from(document.querySelectorAll(`[data-granulometria-asfalto-coluna="${coluna}"]`));
  const atual = event.target.closest?.(`[data-granulometria-asfalto-coluna="${coluna}"]`);
  const indice = campos.indexOf(atual);
  if (indice >= 0 && campos[indice + 1]) {
    campos[indice + 1].focus();
    campos[indice + 1].select();
  }
}

function TabelaEnsaio({ titulo, linhas, determinacoes, calculadas, onChange, media }) {
  return (
    <Paper variant="outlined" sx={{ overflowX: "auto", mb: 2 }}>
      <Table size="small" sx={{ minWidth: 760 }}>
        <TableHead sx={{ backgroundColor: "#f8fafc" }}>
          <TableRow>
            <TableCell colSpan={7} align="center" sx={{ fontWeight: 800, color: "#0f2f5f" }}>{titulo}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ width: 60, fontWeight: 700 }}>Item</TableCell>
            <TableCell sx={{ minWidth: 260, fontWeight: 700 }}>Descrição</TableCell>
            <TableCell sx={{ width: 85, fontWeight: 700 }}>Unid.</TableCell>
            <TableCell sx={{ minWidth: 135, fontWeight: 700 }}>Cálculo</TableCell>
            {[1, 2, 3].map((numero) => <TableCell key={numero} align="center" sx={{ minWidth: 115, fontWeight: 700 }}>{numero}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {linhas.map((linha) => (
            <TableRow key={linha.item}>
              <TableCell align="center">{linha.item}</TableCell>
              <TableCell>{linha.descricao}</TableCell>
              <TableCell align="center">{linha.unidade}</TableCell>
              <TableCell align="center">{linha.calculo || "—"}</TableCell>
              {[0, 1, 2].map((indice) => (
                <TableCell
                  key={indice}
                  align="center"
                  sx={linha.campo ? { backgroundColor: "#ecfdf3", px: 1 } : undefined}
                >
                  {linha.campo ? (
                    <TextField
                      variant="standard"
                      fullWidth
                      value={determinacoes[indice]?.[linha.campo] ?? ""}
                      onChange={(event) => onChange(indice, linha.campo, event.target.value)}
                      onKeyDown={(event) => avancarCampoAbaixo(event, indice)}
                      inputProps={{
                        inputMode: "decimal",
                        style: { textAlign: "center" },
                        "data-caracterizacao-asfalto-coluna": indice,
                      }}
                    />
                  ) : (
                    <Typography color="primary.main" fontWeight={700}>
                      {formatarNumero(calculadas[indice]?.[linha.resultado], linha.casas ?? 3)}
                    </Typography>
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
          {media && (
            <TableRow>
              <TableCell align="center">{media.item}</TableCell>
              <TableCell>{media.descricao}</TableCell>
              <TableCell align="center">{media.unidade}</TableCell>
              <TableCell align="center">{media.calculo}</TableCell>
              <TableCell colSpan={3} align="center">
                <Typography color="primary.main" fontWeight={800}>{formatarNumero(media.valor, media.casas ?? 3)}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default function DetalhesCaracterizacaoAsfalto() {
  const { caracterizacaoAsfaltoId } = useParams();
  const history = useHistory();
  const [registro, setRegistro] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [estadoOriginalEdicao, setEstadoOriginalEdicao] = useState("");
  const [faixasConfiguradas, setFaixasConfiguradas] = useState(faixasDnitAsfaltoPadrao);

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      try {
        const [snapshot, snapshotFaixas] = await Promise.all([
          getDoc(doc(db, COLECAO_CARACTERIZACAO_ASFALTO, caracterizacaoAsfaltoId)),
          getDocs(consultaTenantAtual(collection(db, COLLECTION_FAIXAS_DNIT_ASFALTO))),
        ]);
        if (!snapshot.exists()) {
          if (ativo) setErro("Caracterização não encontrada.");
          return;
        }
        if (ativo) {
          const dados = snapshot.data();
          const granulometria = criarGranulometriaAsfalto(dados.granulometriaAsfalto || []);
          const determinacoes = [0, 1, 2].map((indice) => {
            const item = { ...(dados.determinacoes?.[indice] || {}) };
            if (dados.tipoAgregado === "graudo" && numeroCbuq(item.imerso) === null) {
              const cesto = numeroCbuq(item.cestoReal ?? item.cestoAparente ?? item.cesto);
              const conjunto = numeroCbuq(item.imersoComCestoReal ?? item.imersoComCestoAparente ?? item.imersoComCesto);
              if (cesto !== null && conjunto !== null) item.imerso = conjunto - cesto;
            }
            if (dados.tipoAgregado !== "graudo" && numeroCbuq(item.picnometroAmostraSss) === null) {
              const picnometro = numeroCbuq(item.picnometro);
              const saturada = numeroCbuq(item.saturada);
              if (picnometro !== null && saturada !== null) item.picnometroAmostraSss = picnometro + saturada;
            }
            return item;
          });
          const registroCarregado = {
            id: snapshot.id,
            ...dados,
            determinacoes,
            temperaturaAgua: dados.temperaturaAgua ?? "25",
            faixaDnitAsfalto: dados.faixaDnitAsfalto || "C125",
            dataGranulometria: dados.dataGranulometria || dados.data || "",
            operadorGranulometria: dados.operadorGranulometria || "",
            massaInicialGranulometriaA: dados.massaInicialGranulometriaA || "",
            massaInicialGranulometriaB: dados.massaInicialGranulometriaB || "",
            granulometriaAsfalto: granulometria,
            qualificacao: dados.qualificacao || {},
          };
          const faixasCarregadas = snapshotFaixas.docs
            .map((item) => ({ id: item.id, ...item.data() }))
            .sort((a, b) => Number(a.ordem) - Number(b.ordem));
          setFaixasConfiguradas(faixasCarregadas.length ? faixasCarregadas : faixasDnitAsfaltoPadrao);
          setRegistro(registroCarregado);
          setEstadoOriginalEdicao(serializarEstadoEditavel(registroCarregado));
        }
      } catch (error) {
        console.error("Erro ao carregar caracterização de agregado para asfalto:", error);
        if (ativo) setErro("Não foi possível carregar a caracterização.");
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregar();
    return () => {
      ativo = false;
    };
  }, [caracterizacaoAsfaltoId]);

  const graudo = registro?.tipoAgregado === "graudo";
  const filer = /(^|\s)CAL(\s|$)/i.test(String(registro?.material || "").trim());
  const calculado = useMemo(() => {
    if (!registro) return { determinacoes: [] };
    if (filer) return calcularCaracterizacaoFiler(registro.determinacoes);
    return graudo
      ? calcularCaracterizacaoGraudo(registro.determinacoes, registro.temperaturaAgua)
      : calcularCaracterizacaoMiudo(registro.determinacoes, registro.temperaturaAgua);
  }, [filer, graudo, registro]);
  const densidadeAgua = densidadeAguaPorTemperatura(registro?.temperaturaAgua);
  const granulometriaCalculada = useMemo(
    () => recalcularGranulometriaAsfalto(
      registro?.granulometriaAsfalto || [],
      registro?.massaInicialGranulometriaA || "",
      registro?.massaInicialGranulometriaB || ""
    ),
    [registro?.granulometriaAsfalto, registro?.massaInicialGranulometriaA, registro?.massaInicialGranulometriaB]
  );

  function atualizarDeterminacao(indice, campo, valor) {
    setMensagem("");
    setRegistro((atual) => ({
      ...atual,
      determinacoes: atual.determinacoes.map((item, itemIndice) =>
        itemIndice === indice ? { ...item, [campo]: valor } : item
      ),
    }));
  }

  function atualizarQualificacao(campo, valor) {
    setMensagem("");
    setRegistro((atual) => ({ ...atual, qualificacao: { ...(atual.qualificacao || {}), [campo]: valor } }));
  }

  function atualizarCampoRegistro(campo, valor) {
    setMensagem("");
    setRegistro((atual) => ({ ...atual, [campo]: valor }));
  }

  function atualizarGranulometria(indice, campo, valor) {
    setMensagem("");
    setRegistro((atual) => ({
      ...atual,
      granulometriaAsfalto: atual.granulometriaAsfalto.map((linha, itemIndice) =>
        itemIndice === indice ? { ...linha, [campo]: valor } : linha
      ),
    }));
  }

  async function salvarEnsaio() {
    if (!filer && densidadeAgua === null) {
      setMensagem("Informe a temperatura da água entre 15,6 °C e 29,4 °C.");
      return;
    }
    const temPesoA = registro.granulometriaAsfalto.some((linha) => numeroCbuq(linha.massaA) !== null);
    const temPesoB = registro.granulometriaAsfalto.some((linha) => numeroCbuq(linha.massaB) !== null);
    if ((temPesoA && !(numeroCbuq(registro.massaInicialGranulometriaA) > 0))
      || (temPesoB && !(numeroCbuq(registro.massaInicialGranulometriaB) > 0))) {
      setMensagem("Informe a massa inicial de cada amostra da granulometria antes de salvar.");
      return;
    }
    setSalvando(true);
    setMensagem("");
    try {
      await updateDoc(doc(db, COLECAO_CARACTERIZACAO_ASFALTO, caracterizacaoAsfaltoId), {
        determinacoes: calculado.determinacoes,
        resultados: calculado,
        temperaturaAgua: registro.temperaturaAgua ?? "25",
        faixaDnitAsfalto: registro.faixaDnitAsfalto || "C125",
        dataGranulometria: registro.dataGranulometria || "",
        operadorGranulometria: registro.operadorGranulometria || "",
        massaInicialGranulometriaA: registro.massaInicialGranulometriaA || "",
        massaInicialGranulometriaB: registro.massaInicialGranulometriaB || "",
        granulometriaAsfalto: granulometriaCalculada.granulometria,
        qualificacao: registro.qualificacao || {},
        observacoes: registro.observacoes || "",
        atualizadoEm: new Date(),
      });
      const registroSalvo = {
        ...registro,
        determinacoes: calculado.determinacoes,
        resultados: calculado,
        granulometriaAsfalto: granulometriaCalculada.granulometria,
      };
      setRegistro(registroSalvo);
      setEstadoOriginalEdicao(serializarEstadoEditavel(registroSalvo));
      setMensagem("Ensaio salvo com sucesso.");
    } catch (error) {
      console.error("Erro ao salvar caracterização de agregado para asfalto:", error);
      setMensagem("Não foi possível salvar o ensaio.");
    } finally {
      setSalvando(false);
    }
  }

  async function cancelarAlteracoes() {
    if (!(await confirmarSistema("Deseja cancelar todas as alterações não salvas?"))) return;
    const estadoOriginal = JSON.parse(estadoOriginalEdicao);
    setRegistro((atual) => ({
      ...atual,
      determinacoes: estadoOriginal.determinacoes,
      temperaturaAgua: estadoOriginal.temperaturaAgua,
      faixaDnitAsfalto: estadoOriginal.faixaDnitAsfalto,
      dataGranulometria: estadoOriginal.dataGranulometria,
      operadorGranulometria: estadoOriginal.operadorGranulometria,
      massaInicialGranulometriaA: estadoOriginal.massaInicialGranulometriaA,
      massaInicialGranulometriaB: estadoOriginal.massaInicialGranulometriaB,
      granulometriaAsfalto: estadoOriginal.granulometriaAsfalto,
      observacoes: estadoOriginal.observacoes,
    }));
    setMensagem("");
  }

  if (carregando) {
    return (
      <>
        <Navbar />
        <Box sx={{ display: "grid", placeItems: "center", minHeight: "70vh" }}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (erro || !registro) {
    return (
      <>
        <Navbar />
        <Box sx={{ p: { xs: 2, md: 4 }, pt: 12 }}>
          <Alert severity="error">{erro || "Caracterização não encontrada."}</Alert>
          <Button sx={{ mt: 2 }} startIcon={<ArrowBackIcon />} onClick={() => history.goBack()}>
            Voltar
          </Button>
        </Box>
      </>
    );
  }

  const determinacoesCalculadas = calculado.determinacoes.map((linha) => {
    const umido = numeroCbuq(linha.umido);
    const seco = numeroCbuq(linha.seco);
    return {
      ...linha,
      volumeAbsorcao: umido !== null && seco !== null ? umido - seco : null,
    };
  });
  const temAlteracoes = Boolean(estadoOriginalEdicao) && serializarEstadoEditavel(registro) !== estadoOriginalEdicao;

  return (
    <>
      <Navbar />
      <CabecalhoDetalhes
        titulo="Caracterização de Agregado para Asfalto"
        subtitulo={`${registro.codigo || "-"} - ${filer ? "Material finamente pulverizado (CAL)" : graudo ? "Agregado graúdo" : "Agregado miúdo"} - ${formatarData(registro.data)}`}
      >
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.goBack()}
            disabled={salvando || temAlteracoes}
          >
            Voltar
          </Button>
          {temAlteracoes && (
            <>
              <Button variant="contained" disabled={salvando} onClick={salvarEnsaio}>
                {salvando ? "Salvando..." : "Salvar"}
              </Button>
              <Button data-confirmacao-cancelamento="propria" variant="outlined" disabled={salvando} onClick={cancelarAlteracoes}>
                Cancelar alterações
              </Button>
            </>
          )}
        </Stack>
      </CabecalhoDetalhes>

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        {mensagem && <Alert severity={mensagem.includes("sucesso") ? "success" : "error"} sx={{ mb: 2 }}>{mensagem}</Alert>}
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }, gap: 2, mb: 3 }}>
          <Informacao label="Data" valor={formatarData(registro.data)} />
          <Informacao label="Tipo do agregado" valor={filer ? "Fíler mineral (CAL)" : graudo ? "Graúdo" : "Miúdo"} />
          <Informacao label="Cliente" valor={registro.cliente} />
          <Informacao label="Obra" valor={registro.obra} />
          <Informacao label="Material" valor={[registro.codigoMaterial, registro.material].filter(Boolean).join(" - ")} />
          <Informacao label="Procedência" valor={registro.procedencia} />
          <Informacao label="Camada/Estudo" valor={registro.camadaEstudo} />
        </Box>

        <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
          <Typography fontWeight={800} color="#0f2f5f" mb={2}>Análise granulométrica — concreto betuminoso</Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2, mb: 2 }}>
            <TextField
              select
              size="small"
              label="Faixa DNIT 031/2024–ES"
              value={registro.faixaDnitAsfalto || "C125"}
              onChange={(event) => atualizarCampoRegistro("faixaDnitAsfalto", event.target.value)}
            >
              {FAIXAS_DNIT_ASFALTO.map((faixa) => <MenuItem key={faixa.id} value={faixa.id}>{faixa.label}</MenuItem>)}
            </TextField>
            <TextField
              type="date"
              size="small"
              label="Data da granulometria"
              InputLabelProps={{ shrink: true }}
              value={registro.dataGranulometria || ""}
              onChange={(event) => atualizarCampoRegistro("dataGranulometria", event.target.value)}
            />
            <TextField
              size="small"
              label="Operador"
              value={registro.operadorGranulometria || ""}
              onChange={(event) => atualizarCampoRegistro("operadorGranulometria", event.target.value)}
            />
            <TextField
              size="small"
              label="Massa inicial — Amostra 1 (g)"
              value={registro.massaInicialGranulometriaA || ""}
              onChange={(event) => atualizarCampoRegistro("massaInicialGranulometriaA", event.target.value)}
              inputProps={{ inputMode: "decimal" }}
            />
            <TextField
              size="small"
              label="Massa inicial — Amostra 2 (g)"
              value={registro.massaInicialGranulometriaB || ""}
              onChange={(event) => atualizarCampoRegistro("massaInicialGranulometriaB", event.target.value)}
              inputProps={{ inputMode: "decimal" }}
            />
          </Box>
          <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 1050, "& th, & td": { textAlign: "center", verticalAlign: "middle" } }}>
              <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                <TableRow>
                  <TableCell colSpan={2}>Peneiras</TableCell>
                  <TableCell colSpan={3}>Amostra 1</TableCell>
                  <TableCell colSpan={3}>Amostra 2</TableCell>
                  <TableCell rowSpan={2}>Média<br />% passante</TableCell>
                  <TableCell rowSpan={2}>Faixa DNIT<br />% passante</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ASTM</TableCell>
                  <TableCell>Abertura (mm)</TableCell>
                  <TableCell>Peso (g)</TableCell>
                  <TableCell>% retida acumulada</TableCell>
                  <TableCell>% passando</TableCell>
                  <TableCell>Peso (g)</TableCell>
                  <TableCell>% retida acumulada</TableCell>
                  <TableCell>% passando</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {registro.granulometriaAsfalto.map((linha, indice) => {
                  const calculadaLinha = granulometriaCalculada.granulometria[indice] || {};
                  const configuracao = faixasConfiguradas.find((item) => item.astm === linha.astm);
                  const limite = configuracao?.[registro.faixaDnitAsfalto || "C125"];
                  const textoFaixa = limite?.min || limite?.max ? `${limite.min || "-"} - ${limite.max || "-"}` : "-";
                  return <TableRow key={linha.astm}>
                    <TableCell sx={{ fontWeight: 700 }}>{linha.astm}</TableCell>
                    <TableCell>{linha.abertura}</TableCell>
                    {[
                      ["massaA", 0, calculadaLinha.retidaAcumuladaA, calculadaLinha.passanteA],
                      ["massaB", 1, calculadaLinha.retidaAcumuladaB, calculadaLinha.passanteB],
                    ].flatMap(([campo, coluna, retida, passante]) => [
                      <TableCell key={`${campo}-massa`} sx={{ backgroundColor: "#ecfdf3" }}>
                        <TextField
                          variant="standard"
                          value={linha[campo] || ""}
                          onChange={(event) => atualizarGranulometria(indice, campo, event.target.value)}
                          onKeyDown={(event) => avancarGranulometriaComEnter(event, coluna)}
                          inputProps={{ inputMode: "decimal", style: { textAlign: "center" }, "data-granulometria-asfalto-coluna": coluna }}
                        />
                      </TableCell>,
                      <TableCell key={`${campo}-retida`}>{retida || "-"}</TableCell>,
                      <TableCell key={`${campo}-passante`} sx={{ fontWeight: 700 }}>{passante || "-"}</TableCell>,
                    ])}
                    <TableCell sx={{ color: "#d50000", fontWeight: 800 }}>{calculadaLinha.passanteMedio || "-"}</TableCell>
                    <TableCell>{textoFaixa}</TableCell>
                  </TableRow>;
                })}
                <TableRow sx={{ backgroundColor: "#f8fafc", "& td": { fontWeight: 800 } }}>
                  <TableCell colSpan={2}>Amostra total</TableCell>
                  <TableCell>{formatarNumero(granulometriaCalculada.totalRetidoA, 1)}</TableCell>
                  <TableCell colSpan={2}>—</TableCell>
                  <TableCell>{formatarNumero(granulometriaCalculada.totalRetidoB, 1)}</TableCell>
                  <TableCell colSpan={4}>—</TableCell>
                </TableRow>
                <TableRow sx={{ "& td": { fontWeight: 800 } }}>
                  <TableCell colSpan={2}>Diferença (%)</TableCell>
                  <TableCell>{formatarNumero(granulometriaCalculada.diferencaA, 2)}</TableCell>
                  <TableCell colSpan={2}>—</TableCell>
                  <TableCell>{formatarNumero(granulometriaCalculada.diferencaB, 2)}</TableCell>
                  <TableCell colSpan={4}>—</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Paper>

        {!filer && <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
            <TextField
              size="small"
              label="Temperatura da água (°C)"
              value={registro.temperaturaAgua ?? "25"}
              onChange={(event) => atualizarCampoRegistro("temperaturaAgua", event.target.value)}
              inputProps={{ inputMode: "decimal" }}
              helperText="Faixa da tabela: 15,6 °C a 29,4 °C"
            />
            <Informacao label="Densidade da água corrigida (g/cm³)" valor={formatarNumero(densidadeAgua, 5)} />
          </Stack>
          <Box component="details" sx={{ mt: 1.5 }}>
            <Typography component="summary" color="primary.main" fontWeight={700} sx={{ cursor: "pointer" }}>
              Tabela de densidade da água × temperatura
            </Typography>
            <Table size="small" sx={{ mt: 1, maxWidth: 620 }}>
              <TableHead><TableRow><TableCell align="center">Temperatura (°C)</TableCell><TableCell align="center">Densidade (g/cm³)</TableCell></TableRow></TableHead>
              <TableBody>
                {TABELA_DENSIDADE_AGUA_DNIT.map((item) => (
                  <TableRow key={item.temperatura}>
                    <TableCell align="center">{formatarNumero(item.temperatura, 1)}</TableCell>
                    <TableCell align="center">{formatarNumero(item.densidade, 5)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Typography variant="caption" color="text.secondary">
              Fonte: DNIT 437/2022–ME, Tabela 3; valor de 25 °C conforme DNIT 411/2021–ME e DNIT 413/2021–ME. Valores intermediários são interpolados.
            </Typography>
          </Box>
        </Paper>}

        {filer ? (
          <>
            <TabelaEnsaio
              titulo="Densidade real do material finamente pulverizado — DNER-ME 085/94"
              determinacoes={registro.determinacoes}
              calculadas={determinacoesCalculadas}
              onChange={atualizarDeterminacao}
              linhas={[
                { item: "A", descricao: "Leitura inicial do frasco Le Chatelier", unidade: "cm³", campo: "lechatelierInicial" },
                { item: "B", descricao: "Leitura final do frasco Le Chatelier", unidade: "cm³", campo: "lechatelierFinal" },
                { item: "C", descricao: "Peso do material", unidade: "g", campo: "pesoMaterial" },
                { item: "D", descricao: "Volume deslocado", unidade: "cm³", calculo: "B - A", resultado: "volumeDeslocado", casas: 2 },
                { item: "E", descricao: "Densidade real", unidade: "g/cm³", calculo: "C / D", resultado: "densidadeReal" },
              ]}
            />
            <Paper variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: "#f8fafc" }}>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(5, 1fr)" }, gap: 1 }}>
                <Informacao label="Mínimo (g/cm³)" valor={formatarNumero(calculado.minimo)} />
                <Informacao label="Máximo (g/cm³)" valor={formatarNumero(calculado.maximo)} />
                <Informacao label="Desvio padrão" valor={formatarNumero(calculado.desvioPadrao)} />
                <Informacao label="Diferença" valor={formatarNumero(calculado.diferenca)} />
                <Informacao label="Média (g/cm³)" valor={formatarNumero(calculado.massaEspecificaReal)} />
              </Box>
            </Paper>
          </>
        ) : graudo ? (
          <>
            <TabelaEnsaio
              titulo="Massa específica, densidade relativa e absorção — DNIT 413/2021–ME"
              determinacoes={registro.determinacoes}
              calculadas={determinacoesCalculadas}
              onChange={atualizarDeterminacao}
              linhas={[
                { item: "A", descricao: "Peso do material saturado superfície seca (SSS)", unidade: "g", campo: "umido" },
                { item: "B", descricao: "Peso do material imerso", unidade: "g", campo: "imerso" },
                { item: "C", descricao: "Peso do material seco ao ar", unidade: "g", campo: "seco" },
                { item: "D", descricao: "Densidade relativa aparente (Gsb)", unidade: "—", calculo: "C / (A - B)", resultado: "densidadeRelativaAparente" },
                { item: "E", descricao: "Massa específica real (MEsa)", unidade: "g/cm³", calculo: "[C / (C - B)] × ρágua", resultado: "massaEspecificaReal" },
                { item: "F", descricao: "Massa específica aparente (MEsb)", unidade: "g/cm³", calculo: "[C / (A - B)] × ρágua", resultado: "massaEspecificaAparente" },
                { item: "G", descricao: "Densidade relativa real (Gsa)", unidade: "—", calculo: "C / (C - B)", resultado: "densidadeRelativaReal" },
                { item: "H", descricao: "Absorção", unidade: "%", calculo: "[(A - C) / C] × 100", resultado: "absorcao", casas: 2 },
              ]}
            />
            <Paper variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: "#f8fafc" }}>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(5, 1fr)" }, gap: 1 }}>
                <Informacao label="Gsa médio" valor={formatarNumero(calculado.densidadeRelativaReal)} />
                <Informacao label="Gsb médio" valor={formatarNumero(calculado.densidadeRelativaAparente)} />
                <Informacao label="MEsa média (g/cm³)" valor={formatarNumero(calculado.massaEspecificaReal)} />
                <Informacao label="MEsb média (g/cm³)" valor={formatarNumero(calculado.massaEspecificaAparente)} />
                <Informacao label="Absorção média (%)" valor={formatarNumero(calculado.absorcao, 2)} />
              </Box>
            </Paper>
          </>
        ) : (
          <>
            <TabelaEnsaio
              titulo="Massa específica, densidade relativa e absorção — DNIT 411/2021–ME"
              determinacoes={registro.determinacoes}
              calculadas={determinacoesCalculadas}
              onChange={atualizarDeterminacao}
              linhas={[
                { item: "A", descricao: "Peso do picnômetro vazio", unidade: "g", campo: "picnometro" },
                { item: "B", descricao: "Peso do picnômetro + amostra SSS", unidade: "g", campo: "picnometroAmostraSss" },
                { item: "C", descricao: "Peso do picnômetro + amostra seca", unidade: "g", campo: "picnometroAmostra" },
                { item: "D", descricao: "Peso do picnômetro + amostra + água", unidade: "g", campo: "picnometroAmostraAgua" },
                { item: "E", descricao: "Peso do picnômetro + água", unidade: "g", campo: "picnometroAgua" },
                { item: "F", descricao: "Peso da amostra seca", unidade: "g", calculo: "C - A", resultado: "seca", casas: 1 },
                { item: "G", descricao: "Peso da amostra SSS", unidade: "g", calculo: "B - A", resultado: "saturada", casas: 1 },
                { item: "H", descricao: "Densidade relativa real (Gsa)", unidade: "—", calculo: "F / (F + E - D)", resultado: "densidadeRelativaReal" },
                { item: "I", descricao: "Densidade relativa aparente (Gsb)", unidade: "—", calculo: "F / (G + E - D)", resultado: "densidadeRelativaAparente" },
                { item: "J", descricao: "Massa específica real (MEsa)", unidade: "g/cm³", calculo: "H × ρágua", resultado: "massaEspecificaReal" },
                { item: "K", descricao: "Massa específica aparente (MEsb)", unidade: "g/cm³", calculo: "I × ρágua", resultado: "massaEspecificaAparente" },
                { item: "L", descricao: "Absorção", unidade: "%", calculo: "[(G - F) / F] × 100", resultado: "absorcao", casas: 2 },
              ]}
            />
            <TabelaEnsaio
              titulo="Massa unitária solta"
              determinacoes={registro.determinacoes}
              calculadas={determinacoesCalculadas}
              onChange={atualizarDeterminacao}
              linhas={[
                { item: "G", descricao: "Peso da amostra", unidade: "g", campo: "pesoAmostra" },
                { item: "H", descricao: "Volume do recipiente", unidade: "dm³", campo: "volumeRecipiente" },
                { item: "I", descricao: "Densidade aparente", unidade: "g/dm³", calculo: "G / H", resultado: "massaUnitariaSolta" },
              ]}
              media={{ item: "J", descricao: "Densidade aparente média", unidade: "g/dm³", calculo: "(I1 + I2 + I3) / 3", valor: calculado.massaUnitariaSolta }}
            />
            <Paper variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: "#f8fafc" }}>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(5, 1fr)" }, gap: 1 }}>
                <Informacao label="Gsa médio" valor={formatarNumero(calculado.densidadeRelativaReal)} />
                <Informacao label="Gsb médio" valor={formatarNumero(calculado.densidadeRelativaAparente)} />
                <Informacao label="MEsa média (g/cm³)" valor={formatarNumero(calculado.massaEspecificaReal)} />
                <Informacao label="MEsb média (g/cm³)" valor={formatarNumero(calculado.massaEspecificaAparente)} />
                <Informacao label="Absorção média (%)" valor={formatarNumero(calculado.absorcao, 2)} />
              </Box>
            </Paper>
          </>
        )}

        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Typography fontWeight={800} sx={{ mb: 2 }}>Qualificação do agregado para CBUQ</Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2 }}>
            {graudo ? <>
              <TextField size="small" label="Abrasão Los Angeles (%) — máx. 50" value={registro.qualificacao?.abrasaoLosAngeles || ""} onChange={(event) => atualizarQualificacao("abrasaoLosAngeles", event.target.value)} inputProps={{ inputMode: "decimal" }} />
              <TextField size="small" label="Durabilidade (%) — máx. 12" value={registro.qualificacao?.durabilidade || ""} onChange={(event) => atualizarQualificacao("durabilidade", event.target.value)} inputProps={{ inputMode: "decimal" }} />
              <TextField size="small" label="Índice de forma — mín. 0,50" value={registro.qualificacao?.indiceForma || ""} onChange={(event) => atualizarQualificacao("indiceForma", event.target.value)} inputProps={{ inputMode: "decimal" }} />
              <TextField select size="small" label="Adesividade ao ligante" value={registro.qualificacao?.adesividade || ""} onChange={(event) => atualizarQualificacao("adesividade", event.target.value)}>
                <MenuItem value="">Pendente</MenuItem><MenuItem value="satisfatoria">Satisfatória sem DOP</MenuItem><MenuItem value="satisfatoria_com_dop">Satisfatória com DOP</MenuItem><MenuItem value="nao_satisfatoria">Não satisfatória</MenuItem>
              </TextField>
              <TextField size="small" label="IDM (%) — opcional" value={registro.qualificacao?.idm || ""} onChange={(event) => atualizarQualificacao("idm", event.target.value)} inputProps={{ inputMode: "decimal" }} />
              <TextField size="small" label="IDML (%) — opcional" value={registro.qualificacao?.idml || ""} onChange={(event) => atualizarQualificacao("idml", event.target.value)} inputProps={{ inputMode: "decimal" }} />
            </> : <TextField size="small" label="Equivalente de areia (%) — mín. 55" value={registro.qualificacao?.equivalenteAreia || ""} onChange={(event) => atualizarQualificacao("equivalenteAreia", event.target.value)} inputProps={{ inputMode: "decimal" }} />}
          </Box>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
            DNIT 031/2024–ES; ensaios DNIT 451/2024, DNIT 446/2024, DNIT 424/2020, DNIT 452/2024 e DNIT 450/2024, conforme aplicável ao tipo de agregado.
          </Typography>
        </Paper>

        <TextField
          label="Observações"
          multiline
          minRows={3}
          fullWidth
          value={registro.observacoes || ""}
          onChange={(event) => { setMensagem(""); setRegistro((atual) => ({ ...atual, observacoes: event.target.value })); }}
          sx={{ mb: 2 }}
        />
      </Box>
    </>
  );
}
